// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2124":"71a50bd3892c84613c62","6001":"2408496b6f6d121e8ecb","6033":"23d27de50a719accde0e","7717":"fabb03f9cc181cbc991f","7751":"f4ce08cd8a2c1046a85d","8913":"96d3c9800b73c228a50a"}[chunkId] + ".js";
};